/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import LegendsBanner from '@cont/Banner/LegendsBanner';
import { Spacings } from '@styles/index';
import { noOp } from '@constants/empty';

const LegendsBannerWrapper = styled.div`
  margin-top: ${Spacings.SPACING_6B};
  height: 265px;
  grid-column: span 18;
`;

const EducatorLegendsBanner = ({ course }) => {
  if (!course) return null;

  return (
    <LegendsBannerWrapper>
      <LegendsBanner course={course} enroll={noOp} bannerType={1} />
    </LegendsBannerWrapper>
  );
};

export default EducatorLegendsBanner;
